module.exports = __webpack_public_path__ + "img/dial.0f8dc96a.png";